var OfferService = /*@__PURE__*/ (function () {
    function OfferService(data) {
        if (data.id) {
            this.id = data.id;
        }
        if (data.internalLabel) {
            this.internalLabel = data.internalLabel;
            this.mandatory = this.internalLabel === 'mandatory';
        }
        if (data.overrideLabel) {
            this.internalLabel = data.overrideLabel;
        }
        if (data.maxOccurs) {
            this.maxOccurs = parseInt(data.maxOccurs, 10);
        }
        if (data.minOccurs) {
            this.minOccurs = parseInt(data.minOccurs, 10);
        }
        this.items = [];
    }
    OfferService.prototype.addServiceItem = function (serviceItem) {
        this.items.push(serviceItem);
    };
    OfferService.prototype.getServiceItems = function () {
        return this.items;
    };
    return OfferService;
}());
export { OfferService };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/schema/offer/offer.service.ts
// module id = null
// module chunks = 